import React from 'react'
import { AutoTagging } from 'components/forms/autocomplete/AutoTagging'
import PropTypes from 'prop-types'
import { Calendar, Time } from 'components/forms'

const INITIAL_STATE = {
  body: '',
  showCallback: false,
}

export class DialogNotes extends React.Component {
  constructor(props) {
    super(props)
    this.state = INITIAL_STATE
    this.changeHandler = this.changeHandler.bind(this)
    this.toggleCallback = this.toggleCallback.bind(this)
  }

  toggleCallback(event) {
    event.preventDefault()
    this.setState(prevState => ({ showCallback: !prevState.showCallback }))
    const { onChangeCallback } = this.props
    onChangeCallback()
  }

  changeHandler(value) {
    this.setState({ body: value })
    const { onChangeHandler } = this.props
    onChangeHandler(value)
  }

  render() {
    const { invalidCallback, onChangeCallbackDate, onChangeCallbackTime } = this.props
    const { body, callbackDate, callbackTime, showCallback } = this.state

    return (
      <>
        <div className='notes'>
          <section>
            <div className='row'>
              <div className='col-xs-12'>
                <label htmlFor='body' className='label'>
                  Note
                  <AutoTagging
                    placeholder='Write something...'
                    name='body'
                    value={body}
                    dataTest='status-update-dialog-notes'
                    onChange={this.changeHandler}
                  />
                </label>
              </div>
              <div className='pv4 col-xs-4 col-lg-4 col-md-6'>
                <button
                  className='btn-full-width'
                  data-test='add-callback-btn'
                  onClick={this.toggleCallback}
                  type='button'>
                  {showCallback ? 'Cancel' : 'Add Callback'}
                </button>
              </div>
              {showCallback && (
                <>
                  <div className='col-xs-4'>
                    <Calendar
                      name='callbackDate'
                      value={callbackDate}
                      size='small'
                      placeholder='Date'
                      date={callbackDate}
                      dateTimeChangeToState={onChangeCallbackDate}
                      options={{ enableTime: false, dateFormat: 'm/d/Y' }}
                      dataTest='callback-date'
                    />
                  </div>
                  <div className='col-xs-3'>
                    <Time
                      id='callbackTime'
                      name='callbackTime'
                      value={callbackTime}
                      onChange={onChangeCallbackTime}
                      dataTest='status-update-dialog-callback-time'
                    />
                  </div>
                  {invalidCallback && (
                    <div className='col-xs-12'>
                      <p className='text-warning'>Call back time must be in the future.</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </section>
        </div>
      </>
    )
  }
}

DialogNotes.propTypes = {
  invalidCallback: PropTypes.bool,
  onChangeCallback: PropTypes.func,
  onChangeCallbackDate: PropTypes.func,
  onChangeCallbackTime: PropTypes.func,
  onChangeHandler: PropTypes.func,
}

DialogNotes.defaultProps = {
  invalidCallback: false,
  onChangeCallback: () => {},
  onChangeCallbackDate: () => {},
  onChangeCallbackTime: () => {},
  onChangeHandler: () => {},
}
